import { getCopilotChatDrawerState } from "../store/store";

export function shouldShowBizChatInReadingPane(targetWindow: Window): boolean {
    return ((getCopilotChatDrawerState(targetWindow)?.isShown &&
        getCopilotChatDrawerState(targetWindow)?.showInReadingPane) ??
        false);
}
